import Vue from 'vue';
import axios from 'axios';
import Loading from 'quasar/src/plugins/Loading.js';;
export default {
  namespaced: true,
  state: {
    postReplyData: {},
    // 是否已 load完 postReplyData 的資料
    isFinishPostReplyData: false
  },
  getters: {
    // 取得回覆的所有資訊
    getPostReplyAllData: state => {
      return state.postReplyData;
    },
    // 取得整理排序過的 replyList
    getPostSortReplyList: state => {
      let replyList = state.postReplyData.ReplyList;
      let sortList = [];
      let newList = [];
      for (var i = 0; i < replyList.length; i++) {
        let item = replyList[i];
        // 第一層的留言
        if (item.ParentId.indexOf('GPI') > -1) {
          let map = {
            parentId: ''
          };
          map[item.MsgId] = { ...item, child: [] };
          sortList.push(map);
          newList.push(map[item.MsgId]);
        } else {
          // 屬於回覆其他人的留言
          for (let j = 0; j < sortList.length; j++) {
            let sortItem = sortList[j];
            let parentKey = Object.keys(sortItem)[1];
            // 此留言的父層 ID 等於 第一層的留言 ID 時，
            // 將此留言 data push 進該父層 ID 物件裡的 child
            if (parentKey == item.ParentId) {
              sortItem[parentKey].child.push({ ...item });
              break;
            }
          }
        }
      }

      console.log('整理排序過的 replyList');
      console.log(newList);
      return newList;
    }
  },
  mutations: {
    // 存下目前貼文的回覆內容
    SET_POST_REPLY_DATA(state, data) {
      state.postReplyData = data;
    },

    // 更新是否 load 完 存下目前貼文的回覆內容
    UPDATE_POST_REPLY_LOADING_STATUS(state, data) {
      state.isFinishPostReplyData = data;
    },

    // 更新某則留言的按讚狀態
    UPDATE_REPLY_LIKE_STATUS(state, data) {
      // 用 id 去找 要改哪一個索引的 postWallData
      let idIndex = state.postReplyData.ReplyList.map(item => {
        return item.MsgId;
      }).indexOf(data.targetId);
      state.postReplyData.ReplyList[idIndex].LikeIt = data.flag;
      // 讚數 + 或 - 1
      if (data.flag === 1) {
        state.postReplyData.ReplyList[idIndex].LikeCount += 1;
      } else {
        state.postReplyData.ReplyList[idIndex].LikeCount -= 1;
      }
    }
  },
  actions: {
    // 取得回覆內容
    showApiReply(context, postId) {
      context.commit('UPDATE_POST_REPLY_LOADING_STATUS', false);
      const api = `${process.env.VUE_APP_API_PATH}/showReply`;
      const formData = new FormData();
      formData.append('TargetId', postId);
      axios
        .post(api, formData, {
          headers: { 'Content-Type': 'application/json' }
        })
        .then(res => {
          context.commit('SET_POST_REPLY_DATA', res.data);
          context.commit('UPDATE_POST_REPLY_LOADING_STATUS', true);
          // 更新貼文牆上的留言數量
          context.commit('PostWallModule/UPDATE_POST_WALL_REPLY_COUNT', { postId: postId, replyCount: res.data.ReplyList.length }, { root: true });
        })
        .catch(error => {
          console.error(error);
          Loading.hide();
        });
    },

    // 建立回覆
    createApiReply(context, data) {
      const api = `${process.env.VUE_APP_API_PATH}/createReply`;
      const formData = new FormData();
      formData.append('TargetId', data.targetId);
      formData.append('PostId', data.postId);
      formData.append('Content', data.content);
      formData.append('IsSticker', data.isSticker);
      axios
        .post(api, formData, {
          headers: { 'Content-Type': 'application/json' }
        })
        .then(res => {
          console.log(res.data);
          context.dispatch('showApiReply', data.postId);
        })
        .catch(error => {
          console.error(error);
          Loading.hide();
        });
    }
  }
};
